export const FeatureListApiPath = {
  DOWNLOAD_FEATURE_LIST_EXCEL: '/api/feature-list/excel' // GET Download Feature List Excel
}

export type FeatureListApiPath = (typeof FeatureListApiPath)[keyof typeof FeatureListApiPath]

export interface DownloadFeatureListExcelVars {}

export type DownloadFeatureListExcelResponse = Blob
